<div [formGroup]="form">
  <label
    for="requestType"
    class="block">
    {{ "contactUsForm.quoteOrPolicy.label" | translate }}
    <span class="text-red opacity-60">*</span>
  </label>
  <p-dropdown
    [options]="memberAgreements"
    optionLabel="reference"
    optionValue="id"
    formControlName="selectedReference"
    (onChange)="onSelectReference()"
    [placeholder]="'contactUsForm.quoteOrPolicy.placeholder' | translate"
    class="mt-1 block w-full border border-1 rounded-md shadow-sm"
    inputId="requestType"
    [panelStyle]="{ width: '100%' }"
    [styleClass]="'relative w-full'"
    appendTo="body">
    <ng-template pTemplate="dropdownicon">
      <i class="pi pi-chevron-down absolute right-2 top-1/2 transform -translate-y-1/2"></i>
    </ng-template>
  </p-dropdown>
</div>

<div
  class="mt-4 md:mt-5 mb-2"
  [formGroup]="form">
  <label
    for="requestType"
    class="block">
    {{ "contactUsForm.requestNature.label" | translate }}
    <span class="text-red opacity-60">*</span>
  </label>
  <p-dropdown
    [options]="requestNatureOptions"
    optionLabel="longLabel"
    optionValue="code"
    formControlName="selectedRequestNature"
    (onChange)="onSelectNatureDemand()"
    [placeholder]="'contactUsForm.requestNature.placeholder' | translate"
    class="mt-1 block w-full border border-1 rounded-md shadow-sm"
    inputId="requestType"
    [panelStyle]="{ width: '100%' }"
    [styleClass]="'relative w-full'"
    appendTo="body"
    [ngClass]="{
      'bg-light': form.get('selectedRequestNature')?.disabled,
    }">
    <ng-template pTemplate="dropdownicon">
      <i class="pi pi-chevron-down absolute right-2 top-1/2 transform -translate-y-1/2"></i>
    </ng-template>
  </p-dropdown>
</div>
